import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Clock } from "lucide-react";
import { goToCheckout } from "../../lib/tracking";
import useCountdown from "../../hooks/useCountdown";
import { PRODUCT } from "../../config";

export const StickyCTA = () => {
  const [visible, setVisible] = useState(false);
  const { h, m, s } = useCountdown();

  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 550);
        ticking = false;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 left-0 right-0 z-50 px-3 pb-3 md:px-6 md:pb-4"
          data-testid="sticky-cta-bar"
        >
          <div className="max-w-3xl mx-auto rounded-2xl bg-white/85 backdrop-blur-xl border border-slate-200 shadow-[0_-8px_40px_rgba(15,23,42,0.15)] px-4 py-3 md:px-6 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <div className="flex items-center gap-1.5 text-red-600">
                <Clock className="w-3.5 h-3.5 shrink-0" strokeWidth={2.5} />
                <p className="text-[11px] md:text-xs font-bold uppercase tracking-wide truncate">
                  Promo berakhir hari ini · {h}:{m}:{s}
                </p>
              </div>
              <p className="font-heading font-extrabold text-lg md:text-2xl text-slate-900 leading-tight">
                {PRODUCT.pricePromoLabel}{" "}
                <span className="text-xs md:text-sm font-semibold text-slate-400 line-through">{PRODUCT.priceNormalLabel}</span>
              </p>
            </div>
            <button
              onClick={() => goToCheckout("sticky-bar")}
              data-testid="sticky-cta-button"
              className="cta-pulse shrink-0 rounded-full bg-gradient-to-r from-blue-600 to-cyan-500 text-white font-extrabold text-sm md:text-base px-5 md:px-8 py-3 hover:scale-105 transition-transform whitespace-nowrap"
            >
              ORDER SEKARANG
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
